import React from 'react';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { formActions } from './store/forms-reducer';

import FormGenerator from './FormGenerator/FormGenerator';
import checkValidity from './FormGenerator/checkValidity';
//import * as Actions from './store/forms-actions';

const ReduxForm = (props) => {
  const dispatch = useDispatch();
  const formLabel = props.label ?? 'defaultForm';
  const theForm = useSelector(state => state.forms.forms[formLabel])

  useEffect( () => {
    console.log( 'Initializing Form', formLabel )
    let formEntries = props.entries;
    if ( Array.isArray( props.entries) ) {
      formEntries = FormGenerator.arrayFormToHash( props.entries );
    }

    dispatch( formActions.addForm({
      label: formLabel,
      entries: formEntries,
      initialState: FormGenerator.initFormState( props.entries )
    }));

    if ( props.fetchData ) {
      props.fetchData()
      .then( data => {
        console.log( 'fetched data ', data );
         Object.keys( data ).forEach( key => {
          console.log( key, data[key]);
          const newElState = {
            value: data[key],
            touched: false,
            valid: true,
            message: ""
          }
          dispatch( formActions.changeFormValue({
            label: formLabel, 
            field: key, 
            state: newElState
          }))
         })
      })
    }
  }, []);

  const inputChangedHandler = (event, key) => {
    const oldElState = theForm.state[key];
    const newElState = {
      ...oldElState
    };
    if ( theForm.entries[key].tag === 'boxes') {
      newElState.value = event.target.value;
      if (event.target.checked) {
        if ( theForm.entries[key].attributes.type === 'switch' ) {
          newElState.value = event.target.value;
        } else {
          newElState.value = oldElState.value.concat( event.target.value );
        }
      } else {
        if ( theForm.entries[key].attributes.type === 'switch' ) {
          newElState.value = '';
        } else {
          newElState.value = oldElState.value.filter( el => (el !== event.target.value));
        }
      }
    } else {
      const rawValue = event.target.value;
      newElState.value = theForm.entries[key].attributes?.type === 'email'
        ? rawValue.replace(/\s/g, '')
        : rawValue;
    }

    newElState.valid = checkValidity( newElState.value, theForm.entries[key].validation );
    newElState.touched = true;

    dispatch( formActions.changeFormValue({
      label: formLabel, 
      field: key, 
      state: newElState
    }));

    if ( props.onChange ){
      props.onChange( key, event.target.value, newElState.valid )
    }

  }

  let form = null;
  if (theForm !== undefined) {
    form = <FormGenerator
      entries={props.entries}
      name={theForm.entries}
      state={theForm.state}
      isValid={theForm.isValid}
      onChange={inputChangedHandler}
      onSubmit={props.onSubmit}
      submitButtonLabel={props.submitButtonLabel}
    />
  }

  return <>{form}</>;

}

export const errorMessages = () => {

}
export default ReduxForm;

/*
props:
  entries: (the form)
  label: 
  onChange: callback( key, value, valid )
*/
